/**
 * @author Raghav Prabhu
 */
 import service from '../Common/'
 import constants from '../../../settings/shared/constants'

  /**
   * Get current user
   */
  function getCurrentUsert() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
     return service({
        url: constants.api.user.userProfile,
        method: 'GET',
        headers: headers,
        data:   ''
    });
 }
 
 function getAllUsers(uid) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.getAllusers+"/"+uid,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function getChatUsers() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.chatUses,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

  function getuserRole(uid) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.getRole+"/"+uid,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

  function PostNewUser(Udata) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.postNewUser,
            method: 'POST',
            headers: headers,
            data:  Udata
        }); 
 }

   function UpdateUser(updateData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.updateUser+"/"+id,
            method: 'PUT',
            headers: headers,
            data:  updateData
        }); 
 }

    function DeleteUser(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.deleteUser+"/"+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }

function ActivateUser(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.activateUser+"/"+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function DeActivateUser(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.deactivateUser+"/"+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

  function UpdatePassword(changeDetails) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
        url: constants.api.user.updatePassword,
            method: 'POST',
            headers: headers,
            data:  changeDetails
        }); 
 }

//To export authentication function
const UserService = {
    getCurrentUsert,getAllUsers,PostNewUser,getuserRole,UpdateUser,
    getChatUsers,DeleteUser,ActivateUser,DeActivateUser,UpdatePassword
}

export default UserService;
